export enum AppEnumConstants {
  CHECKBOX = 'checkbox',
  MULTISELECT = 'multiSelect',
  INPUT = 'input',
  DATE = 'date',
  DATE_RANGE = 'dateRange',
  DROPDOWN = 'dropdown',
  ACTION_BUTTON = 'actionButton',
  EXPAND = 'expand',
  DELETE_BTN = 'deleteButton',
  ACTION_BUTTON_FEILD_NAME = 'action',
  NUMERIC = 'numeric',
  NUMBER = 'number',
  STATUS_APPROVED = 'A',
  STATUS_NOT_ASSIGNED = 'N',
  STATUS_PENDING = 'P',
  STATUS_REJECT = 'R',
  STATUS_REJECTED = 'Rejected',
  STATUS_VOID = 'Void',
  STATUS_COMMON = 'C',
  STATUS_CLOSED = 'C',
  STATUS_SUCCESS = 'S',
  STATUS_HOLD = 'W',
  STATUS_FAILED = 'F',
  STATUS_READY = 'B',
  STATUS_PROCCESSING = 'O',
  STATUS_UNPROCCCESSED = 'N',
  STATUS_CLOSE = 'Closed',
  STATUS_PAID = 'Paid',
  STATUS_NOT_PAID = 'Not-Paid',
  STATUS_PARTIALLY_PAID = 'Partially-Paid',
  STATUS_MAILED = 'Mailed',
  STATUS_LETTER_MAILED = 'M',
  STATUS_OPEN = 'Open',
  STATUS_ACTIVE = 'Active',
  STATUS_DELETED = 'D',
  STATUS_DONE = 'Y',
  STATUS_NOT_PROCESSED = 'N',
  STATUS_INACTIVE = 'Inactive',
  STATUS_E_BILL = 'E',
  STATUS_NOT_E_BILL = 'O',
  STATUS_NOT_EXPORTED = 'NE',
  STATUS_REQUESTED = 'REQ',
  STATUS_YES = 'Y',
  STATUS_DRAFT = 'T',
  STATUS_EMAIL_LABEL_SENT = 'Sent',
  STATUS_UNDER_DISCUSSION = 'U',
  STATUS_EMAIL_LABEL_NOT_SENT = 'Not-Sent',
  STATUS_LOCK = 'Locked',
  LABEL_UNDER_DISCUSSION = 'UNDER-DISCUSSION',
  LABEL_APPROVED = 'APPROVED',
  LABEL_NOT_ASSIGNED = 'NOT-ASSIGNED',
  LABEL_NOT_SENT = 'Not-Assigned',
  LABEL_PENDING = 'PENDING',
  LABEL_HOLD = 'ON-HOLD',
  LABEL_OPEN = 'OPEN',
  LABEL_REJECT = 'REJECTED',
  LABEL_READY = 'READY',
  LABEL_SUCCESS = 'SUCCESS',
  LABEL_VOID = 'VOID',
  LABEL_ACTIVE = 'ACTIVE',
  LABEL_INACTIVE = 'INACTIVE',
  LABEL_LOCK = 'LOCKED',
  LABEL_CLOSED = 'CLOSED',
  LABEL_PAID = 'PAID',
  LABEL_DELETED = 'DELETED',
  LABEL_MAILED = 'MAILED',
  LABEL_EXPORTED = 'EXPORTED',
  LABEL_NOT_EXPORTED = 'NOT-EXPORTED',
  LABEL_REQUESTED = 'REQUESTED',
  LABEL_REQUIRED = 'REQUIRED',
  LABEL_OPTIONAL = 'OPTIONAL',
  LABEL_EMAIL_SENT = 'SENT',
  LABEL_FAILED = 'FAILED',
  LABEL_EMAIL_NOT_SENT = 'NOT-SENT',
  STATUS_REQUIRED = 'Required',
  STATUS_OPTIONAL = 'Optional',
  LABEL_TAXABLE = 'TAXABLE',
  LABEL_CANCELED = 'CANCELED',
  LABEL_NOT_TAXABLE = 'NONTAXABLE',
  STATUS_TAXABLE = 'Taxable',
  STATUS_CANCELED = 'Canceled',
  STATUS_NOT_TAXABLE = 'Not Taxable',
  LABEL_DELETION_PENDING = 'DELETION-PENDING',
  LABEL_DRAFT = 'DRAFT',
  LABEL_MANDATORY = '*',
  LABEL_EMPTY_STRING = '',
  LABEL_DOT_STRING = '.',
  LENGTH_ZERO = 0,
  PAYMENT_STATUS_PAID = 'Y',
  STATUS_LETTER_INACTIVE = 'I',
  STATUS_LETTER_ACTIVE = 'A',
  STATUS_LETTER_CANCELED = 'C',
  STATUS_LETTER_EXPIRED = 'X',
  PAYMENT_STATUS_PROCESSING = 'O',
  PAYMENT_APPLIED_CREDIT = 'C',
  PAYMENT_UNAPPLIED_CREDIT = 'U',
  PAYMENT_PARTIALLY_APPLIED_CREDIT = 'G',
  PAYMENT_STATUS_NOT_PAID = 'N',
  PAYMENT_STATUS_PARTIALLY_PAID = 'H',
  PAYMENT_LABEL_PARTIALLY_PAID = 'PARTIALLY-PAID',
  PAYMENT_LABEL_PROCESSING = 'PROCESSING',
  PAYMENT_LABEL_APPLIED_CREDIT = 'APPLIED-CREDIT',
  PAYMENT_LABEL_UNAPPLIED_CREDIT = 'UNAPPLIED-CREDIT',
  PAYMENT_LABEL_PARTIALLY_APPLIED_CREDIT = 'PARTIALLY-APPLIED-CREDIT',
  EXPORT_STATUS_EXPORT = 'Exported',
  EXPORT_STATUS_NOT_EXPORT = 'Not-Exported',
  PAYMENT_LABEL_PAID = 'PAID',
  PAYMENT_LABEL_NOT_PAID = 'NOT-PAID',
  PAYMENT_LABEL_UNPAID = 'UNPAID',
  EXPORT_LABEL_EXPORT = 'EXPORTED',
  EXPORT_LABEL_NOT_EXPORT = 'NOT-EXPORTED',
  INVOICE_TYPE_E = 'E',
  INVOICE_TYPE_R = 'R',
  STATUS_NO = 'N',
  PO_ACCOUNT_STATUS_YES = 'Z',
  PO_ACCOUNT_STATUS_NO = 'Q',
  PO_LABEL_PO_ACCOUNT_STATUS_YES = 'YES',
  PO_LABEL_PO_ACCOUNT_STATUS_NO = 'NO',
  BILL_SUBMITTED_STATUS_SUBMITTED = 'S',
  BILL_SUBMITTED_LABEL_SUBMITTED = 'Submitted',
  BILL_PAYMENT_STATUS_PENDING = 'Pending',
  BILL_PAYMENT_STATUS_COMPLETED = 'Completed',
  BILL_PAYMENT_LABEL_PENDING = 'PENDING',
  BILL_PAYMENT_LABEL_COMPLETED = 'COMPLETED',
  LABEL_UNPROCESSED = 'UNPROCESSED',
  LABEL_PROCESSED = 'PROCESSED',
  LABEL_PUBLISHED = 'PUBLISHED',
  LABEL_PROCCESING = 'PROCESSING',
  ST_APPROVED = 'Approved',
  ST_PENDING = 'Pending',
  ST_REJECTED = 'Rejected',
  LABEL_EXPIRED = 'EXPIRED',


  // FIELD DATA TYPE
  FIELD_DATA_TYPE_TEXT = 'text',
  FIELD_DATA_TYPE_DECIMAL = 'decimal',
  FIELD_DATA_TYPE_INT = 'int',
  FIELD_DATE_TYPE_DATE = 'date',

  // Number Only Regex
  NUMBER_ONLY_REGEX = '^[0-9]*$',
  // Number Only and .
  NUMBER_ONLY_AND_DOT_REGEX = '^[0-9.]*$',

  // DEFAULT COUNTRY
  DEFAULT_COUNTRY = 'United States',

  // URLS
  BILL_URL = '/home/bills',
  PURCHASE_ORDER_URL = '/home/purchase-order',
  PURCHASE_ORDER_RECEIPT_URL = '/home/purchase-order", {"tab": 1}',
  EXPENSE_URL = '/home/expense',
  PAYMENT_URL = '/home/payments',
  VENDOR_URL = '/home/vendor',
  CREDIT_NOTE_URL = '/home/bills',

  VENDOR_INVOICE_URL = '/vendor/invoices',
  VENDOR_PURCHASE_ORDER_URL = '/vendor/purchase-orders',
  VENDOR_CUSTOMER_URL = '/vendor/customers',


  // Notification Types
  NOTIFICATION_STATUS_READ = 'R',
  NOTIFICATION_STATUS_UNREAD = 'U',
  NOTIFICATION_STATUS_READ_CLASS = 'read',
  NOTIFICATION_STATUS_UNREAD_CLASS = 'unread',

  // Notification Types
  NOTIFICATION_TYPE_BILL = 1,
  NOTIFICATION_TYPE_VENDOR = 6,
  NOTIFICATION_TYPE_PO = 2,
  NOTIFICATION_TYPE_EXPENSE = 4,
  NOTIFICATION_TYPE_PAYMENT = 5,
  NOTIFICATION_TYPE_PO_RECEIPT = 3,
  NOTIFICATION_TYPE_AUTOMATION = 7,
  NOTIFICATION_TYPE_CREDIT_NOTE = 8,
  NOTIFICATION_TYPE_CREDIT_CARD = 9,
  NOTIFICATION_TYPE_CREDIT_CARD_RECEIPT = 10,
  NOTIFICATION_TYPE_DELEGATE_USER = 11,

  // Notification Category Colour
  NOTIFICATION_CATEGORY_BILL = 'bill',
  NOTIFICATION_CATEGORY_VENDOR = 'vendor',
  NOTIFICATION_CATEGORY_PO = 'po',
  NOTIFICATION_CATEGORY_EXPENSE = 'expense',
  NOTIFICATION_CATEGORY_PAYMENT = 'payment',
  NOTIFICATION_CATEGORY_PO_RECEIPT = 'po-receipt',
  NOTIFICATION_CATEGORY_AUTOMATION = 'automation',
  NOTIFICATION_CREDIT_NOTE = 'credit-note',
  NOTIFICATION_CREDIT_CARD = 'credit-card',
  NOTIFICATION_CREDIT_CARD_RECEIPT = 'receipt',
  NOTIFICATION_DELEGATE = 'delegate',

  /**
   * APPROVED BILL CHILD TABLE STATUS
   */
  STATUS_APPROVAL_PENDING = 'AP',
  STATUS_TRANSACTION_PENDING = 'TP',
  STATUS_TRANSACTION_SUCCESS = 'TS',
  STATUS_TRANSACTION_FAILED = 'TF',
  STATUS_TRANSACTION_SUBMITTED = 'TU',
  STATUS_TRANSACTION_CANCELED = 'TC',
  STATUS_TRANSACTION_UNPROCESSED = 'No',
  STATUS_TRANSACTION_IN_PROGRESS = 'TI',
  STATUS_TRANSACTION_SUSPENDED = 'TH',
  STATUS_TRANSACTION_CREATED = 'TK',
  STATUS_STOP_PAYMENT = 'TT',
  STATUS_RETURN_CHECK = 'TR',
  STATUS_USB_CHECK_INITIATED = 'initiated',
  STATUS_USB_CHECK_ACCEPTED = 'accepted',
  STATUS_USB_CHECK_REJECTED = 'rejected',
  STATUS_USB_CHECK_DELETED = 'deleted',
  STATUS_ACH_REQUEST_RECEIVED = 'request received',
  STATUS_ACH_TRANSFER_IN_PROGRESS = 'transfer in progress',
  STATUS_ACH_REQUEST_COMPLETE = 'request complete',
  STATUS_ACH_TRANSFER_RETURNED = 'transfer returned',
  STATUS_ACH_TRANSFER_CANCELLED = 'transfer cancelled',
  STATUS_CHECKEEPER_PENDING = 'pending',
  STATUS_CHECKEEPER_PRINTED = 'printed',
  STATUS_CHECKEEPER_MAILED = 'mailed',
  STATUS_PROVIDER_SUBMITTED = 'submitted',
  STATUS_VIRTUAL_CARD_APPROVAL = 'approval',
  STATUS_ACH_DECLINE = 'decline',
  STATUS_NOT_AVAILABLE = 'not available',

  STATUS_CHECKEEPER_CANCELED = 'Canceled',
  STATUS_VIRTUAL_CARD_OPEN = 'open',
  STATUS_VIRTUAL_CARD_CANCELED = 'cancelled',
  STATUS_VIRTUAL_CARD_EXPIRED = 'expired',
  STATUS_CANCELLED = 'cancelled',

  ACH_PAYMENT_TYPE_STRING = 'ACH',
  CHECK_PAYMENT_TYPE_STRING = 'Check',
  VIRTUAL_CARD_PAYMENT_TYPE_STRING = 'Virtual Card',
  VIRTUAL_CARD_STATUS_APPROVAL = 'Approval',
  ACH_STATUS_DECLINE = 'Decline',
  STATUS_ACH_PRINTED = 'printed',
  STATUS_ACH_UNKNOWN = 'unknown',

  /**
   * APPROVED BILL CHILD TABLE LABELS
   */

  LABEL_APPROVAL_PENDING = 'APPROVAL-PENDING',
  LABEL_TRANSACTION_PENDING = 'PENDING',
  LABEL_TRANSACTION_SUCCESS = 'SUCCESS',
  LABEL_TRANSACTION_FAILED = 'FAILED',
  LABEL_TRANSACTION_SUBMITTED = 'SUBMITTED',
  LABEL_TRANSACTION_CANCELED = 'CANCELED',
  LABEL_TRANSACTION_SUSPENDED = 'SUSPENDED',
  LABEL_TRANSACTION_CREATED = 'CREATED',
  LABEL_STOP_PAYMENT = 'STOP-PAYMENT',
  LABEL_CHECK_RETURN = 'RETURNED',
  LABEL_ON_HOLD = 'ON-HOLD',
  LABEL_NOT_APPLICABLE = 'NOT-APPLICABLE',
  LABEL_ACH_REQUEST_RECEIVED = 'REQUEST-RECEIVED',
  LABEL_ACH_TRANSFER_IN_PROGRESS = 'TRANSFER-IN-PROGRESS',
  LABEL_ACH_REQUEST_COMPLETE = 'REQUEST-COMPLETE',
  LABEL_ACH_TRANSFER_RETURNED = 'TRANSFER-RETURNED',
  LABEL_ACH_TRANSFER_CANCELLED = 'TRANSFER-CANCELLED',
  LABEL_USB_CHECK_INITIATED = 'INITIATED',
  LABEL_USB_CHECK_ACCEPTED = 'ACCEPTED',
  LABEL_USB_CHECK_REJECTED = 'REJECTED',
  LABEL_USB_CHECK_DELETED = 'DELETED',
  LABEL_CHECKEEPER_PENDING = 'PENDING',
  LABEL_CHECKEEPER_PRINTED = 'Printed',
  LABEL_CHECKEEPER_MAILED = 'Mailed',
  LABEL_NOT_AVAILABLE = 'NOT-AVAILABLE',
  LABEL_ACH_UNKNOWN = 'UNKNOWN',

  STATUS_PROCESSED = 'Pr',

  STATUS_JIRA_CANCELED = 'Canceled',
  STATUS_JIRA_W_SUPPORT = 'Waiting for support',
  STATUS_JIRA_DONE = 'Done',
  STATUS_JIRA_ESCALATED = 'Escalated',
  STATUS_JIRA_IN_PROGRESS = 'In Progress',
  STATUS_JIRA_REOPENED = 'Reopened',
  STATUS_JIRA_RESOLVED = 'Resolved',
  STATUS_JIRA_W_CUSTOMER = 'Waiting for customer',

  LABEL_JIRA_W_SUPPORT = 'WAITING-FOR-SUPPORT',
  LABEL_JIRA_DONE = 'DONE',
  LABEL_JIRA_ESCALATED = 'ESCALATED',
  LABEL_JIRA_IN_PROGRESS = 'IN-PROGRESS',
  LABEL_JIRA_REOPENED = 'RE-OPENED',
  LABEL_JIRA_RESOLVED = 'RESOLVED',
  LABEL_JIRA_W_CUSTOMER = 'WAITING-FOR-CUSTOMER',

  // CREDIT_CARD
  BILL_TYPE_CREDIT_CARD = 'C',
  CARD_TYPE_DIGITAL = 'D',
  CARD_TYPE_VIRTUAL = 'V',

  BILLS_TAB = 'Bills',
  BILL_TEMPLATE_TAB = 'Bill Templates',
  RECURRING_BILLS_TAB = 'Recurring Bills',
  CREDIT_NOTE_TAB = 'Credit Notes',

  PURCHASE_ORDERS_TAB = 'Purchase Orders',
  PO_RECEIPTS_TAB = 'PO Receipts',

  USER_TAB = 'Users',
  ROLES_TAB = 'Roles',
  APPROVAL_GROUPS_TAB = 'Approval Groups',

  ACCOUNT_DP = 'accountDp',
  PROJECT_TASK_DP = 'projectTaskDp',
  DEPARTMENT_DP = 'departmentDp',

  VENDORS_TAB = 'Vendors',
  VENDOR_INVITATIONS = 'Vendor Invitations',
  VENDOR_GROUP_TAB = 'Vendor Groups',

  // unattended payment
  DAY = 'Day',
  WEEK = 'Week',
  MONTH = 'Month',
  HOUR = 'Hour',

  PAYMENT_TYPE = 'txn.txnType',
  PAYMENT_PROVIDER_NAME = 'txn.providerName',
  CHECKEEPER = 'Checkeeper',
  USB_CHECK = 'US Bank',
  USB_CHECK_LINK = 'https://help.papertrl.com/payments?index=6&id=usBank',
  USB_ACH_LINK = 'https://help.papertrl.com/payments?index=6&id=usBankACH',
  CHECKEEPER_LINK = 'https://help.papertrl.com/payments?index=6&id=checkeeper',
  VIRTUAL_CARD_LINK = 'https://help.papertrl.com/payments?index=6&id=usBankCard',
  _BLANK = '_blank',

  FIELD_ADDI_FIELDS = 'ADDI-FIELDS',
  FIELD_VENDORS = 'VENDORS',
  FIELD_TERMS = 'TERMS',
  FIELD_APPROVAL_GROUPS = 'APPROVAL-GROUPS',
  FIELD_DEPARTMENTS = 'DEPARTMENTS',
  FIELD_PROJECTS = 'PROJECTS',
  FIELD_ACC_PROJECT = 'ACC-PROJECTS',
  FIELD_INVOICES = 'INVOICES',
  FIELD_DATE_FORMATS = 'DATE-FORMATS',
  FIELD_INTERVAL = 'INTERVAL',
  FIELD_WEEKS = 'WEEKS',
  FIELD_DAYS = 'DAYS',
  FIELD_MONTHS = 'MONTHS',
  FIELD_CUSTOM_INTERVAL = 'CUSTOM-INTERVAL',
  FIELD_RECURRING_GENERATION = 'RECURRING-GENERATION',
  FIELD_RECURRING_OCCURRENCE = 'RECURRING-OCCURRENCE',
  FIELD_SEPARATORS = 'SEPARATORS',

  /**
   * Sentry Error Constants
   */

  // Payments
  CREATE_PAYMENT = 'CREATE_PAYMENT',
  PAYMENT = 'PAYMENT',
  APPROVE_PAYMENT = 'APPROVE_PAYMENT',
  CREATE_PAYMENT_COMPONENT = 'CREATE_PAYMENT_COMPONENT',
  PAYMENT_APPROVE_COMPONENT = 'PAYMENT_APPROVE_COMPONENT',
  BULK_ERROR_COMPONENT = 'BULK_ERROR_COMPONENT',
  PAYMENT_SUMMARY_COMPONENT = 'PAYMENT_SUMMARY_COMPONENT',
  CREATE_PAYMENT_GET_DISCOUNT_AMOUNT_METHOD = 'GET_DISCOUNT_AMOUNT_METHOD',
  CREATE_PAYMENT_ROW_SELECTED_METHOD = 'ROW_SELECTED_METHOD',
  CREATE_PAYMENT_SUBMIT_PAYMENT_METHOD = 'SUBMIT_PAYMENT_METHOD',
  CREATE_PAYMENT_CREATE_PAYMENT_METHOD = 'CREATE_PAYMENT_METHOD',

  // Log In
  LOGIN_COMPONENT = 'LOGIN_COMPONENT',
  LOGIN = 'LOGIN',
  AUTH = 'AUTH',
  NAVIGATE_DASHBOARD = 'NAVIGATE_DASHBOARD',

  // Reset Password
  PASSWORD_RESET = 'PASSWORD_RESET',
  PASSWORD_RESET_COMPONENT = 'PASSWORD_RESET_COMPONENT',

  // Routing
  ROUTING = 'ROUTING',
  ROUTING_COMPONENT = 'ROUTING_COMPONENT',

  // Top Bar
  TOP_BAR_COMPONENT = 'TOP_BAR_COMPONENT',
  CHANGE_SUB_ACCOUNT = 'CHANGE_SUB_ACCOUNT',

  // Support Ticket
  CREATE_SUPPORT_TICKET = 'CREATE_SUPPORT_TICKET',
  SUPPORT_TICKET_COMPONENT = 'SUPPORT_TICKET_COMPONENT',
  SUPPORT_TICKET = 'SUPPORT_TICKET',

  // Inbox
  INBOX_COMPONENT = 'INBOX_COMPONENT',
  UPLOAD_INBOX_DOCUMENT = 'UPLOAD_INBOX_DOCUMENT',
  SAVE_ATTACHMENT = 'SAVE_ATTACHMENT',
  DELETE_INBOX_EMAIL = 'DELETE_INBOX_EMAIL',
  SEND_ATTACHMENT = 'SEND_ATTACHMENT',
  INBOX = 'INBOX',

  // Item
  ITEM_COMPONENT = 'ITEM_COMPONENT',
  ITEM_CREATE = 'ITEM_CREATE',
  ITEM = 'ITEM',

  // API
  API_ERROR = 'API_ERROR'
}
